import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import Pagination from '../paginnation';
import { apiGetPage } from '../../request/api'
import { Spin } from 'antd';
import NotHaveInfo from '../nothaveinfo';

interface MangementProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface PageData {
    orderName: string;
    payType: string;
    price: string;
    status: string;
    created_at: string;
    updated_at: string;
    id: string;
    applyInvoice_at: string;
    invoicing_at: string;
    invoiceStatus: string;
}

const Mangement: React.FC<MangementProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [partList, setPartList] = useState<PageData[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        apiGetPage({
            tid: '4DCDCEA81A6C40618E5C121024774B64',
            page: 1,
            size: 1000,
            search: 'status=1',
            sort: 'invoiceStatus'
        }).then(res => {
            setPartList(res.data.data.rows)
            setLoading(false);
            console.log(res.data.data.rows);
        }).catch(err => {
            setLoading(false);
            console.log(err)
        });
    }, []);

    const itemsPerPage = 6; // 每页显示的条目数
    const totalItems = partList.length;
    const [currentPage, setCurrentPage] = useState(1);
    const formatDate = (dateString: string) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date');
            }

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始
            const day = date.getDate().toString().padStart(2, '0');

            return `${year}.${month}.${day}`;
        } catch (error) {
            console.error('日期解析错误:', error);
            return '日期格式错误';
        }
    };
    const godetali = (index: number, id: string) => {
        if (index == 0) {
            handleViewChange('choosemanagement', id)
        } else if (index == 1) {
            handleViewChange('managementdetail', id)
        } else {
            console.log('下载')
            // handleViewChange('managementdetail', id)
        }
    }
    const manageInvoices = () => {
        handleViewChange('manageinvoices', 111111)
    }
    return (
        <Spin spinning={loading} tip="">
            <div className="WorkOrder">
                <p className='order-header' style={{ color: themeColor }} onClick={manageInvoices}>发票信息管理</p>
                <div className="work-title">
                    <span style={{ width: '240px' }}>订单编号</span>
                    <span style={{ width: '80px' }}>开票金额</span>
                    <span style={{ width: '96px' }}>申请时间</span>
                    <span style={{ width: '96px' }}>发票状态</span>
                    <span style={{ width: '56px' }}>操作</span>
                </div>
                {partList.slice((currentPage - 1) * 6, currentPage * itemsPerPage).map((item, index) => (
                    <div key={index} className="order-item">
                        <div className="order-name">{item.id}</div>
                        <div className="order-price">{item.price}</div>
                        {item.invoiceStatus !== '0' && <div className="order-time">{formatDate(item.applyInvoice_at)}</div>}
                        {item.invoiceStatus === '0' && <div className="order-time">- -</div>}

                        {item.invoiceStatus === '0' && <div className="order-takeTime" style={{ color: themeColor }}>未申请</div>}
                        {item.invoiceStatus === '1' && <div className="order-takeTime">待开票</div>}
                        {item.invoiceStatus === '2' && <div className="order-takeTime">已开票</div>}

                        {item.invoiceStatus === '0' && <div className="order-states" onClick={() => godetali(0, item.id)} style={{ color: themeColor }}>开票</div>}
                        {item.invoiceStatus === '1' && <div className="order-states" onClick={() => godetali(1, item.id)}>查看</div>}
                        {item.invoiceStatus === '2' && <div className="order-states" > <span onClick={() => godetali(1, item.id)}>查看</span><span onClick={() => godetali(2, item.id)}>下载</span>   </div>}
                    </div>
                ))}
                {!loading && totalItems == 0 && (
                    <NotHaveInfo />
                )}
                {totalItems > itemsPerPage && (
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        themeColor={themeColor}
                    />
                )}
            </div>
        </Spin>

    );
};

export default Mangement;